export default "__VITE_ASSET__EJ8ByQEq__"